import { render, staticRenderFns } from "./user-update.html?vue&type=template&id=1275390b&scoped=true&"
import script from "./user-update.js?vue&type=script&lang=js&"
export * from "./user-update.js?vue&type=script&lang=js&"
import style0 from "./user-update.scss?vue&type=style&index=0&id=1275390b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275390b",
  null
  
)

export default component.exports